var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_vm._v(" "+_vm._s(_vm.prisoner.base_number)+" "+_vm._s(_vm.prisoner.gender)+" "+_vm._s(_vm.prisoner.birth_date)+" ")]):_c('div',[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }